var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconLoved = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3999,
    cy: 16,
    r: 15.4074,
    fill: "#F96C6C",
    stroke: "white",
    strokeWidth: 1.18519
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3999 25.6648C16.3463 25.6648 16.2969 25.6565 16.2474 25.6359C14.1367 24.8032 9.48253 21.3115 7.70577 17.3169C5.97024 13.4047 7.34712 10.148 9.47841 8.65569C11.5891 7.17987 14.2687 7.43958 16.3999 9.29879C18.5312 7.43958 21.2108 7.17987 23.3215 8.65569C25.4528 10.148 26.8296 13.4047 25.0941 17.3169C23.3215 21.3156 18.6631 24.8032 16.5525 25.6359C16.503 25.6565 16.4494 25.6648 16.3999 25.6648Z",
    stroke: "#802626",
    strokeWidth: 1.18519,
    strokeMiterlimit: 10
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconLoved, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/iconLoved.7fc40c11.svg";
export { ForwardRef as ReactComponent };